module.exports = __webpack_public_path__ + "img/bk.9920b0eb.png";